import React from "react";
import { AddGiftCardScreenContext } from "./context";

export const useAddGiftCardProductScreenProvider = () => {
  const context = React.useContext(AddGiftCardScreenContext);
  if (!context) {
    throw new Error("No AddGiftCardScreenContext context was provided. ");
  }
  return context;
};
